import React, { useCallback, useState,useRef } from "react";
import "devextreme/data/odata/store";
import { GridLayout } from "../../../../common/GridLayout";
import { Localization } from "../../../../common/Localization";
import { Button } from 'devextreme-react/button';
import {
  Column,
  DataGrid,
  FilterRow,
  FilterPanel,
  Sorting,
  Paging,
  Pager,
  LoadPanel,
  Export,
  ColumnHeaderFilter,
  ColumnChooser,
  ColumnChooserSearch,
  Selection,
  StateStoring,
  Item,
  Toolbar
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
export default (props) => {
  const dataGrid = useRef(null);
  const allowedPageSizes = [10, 20, 100, 300];
  const onSelectionChanged = ({ selectedRowsData }) => {
    const selectedData = selectedRowsData[0];
    if (selectedRowsData.length === 1) {
      props.parentCallback(selectedData);
      props.enableDisableLocBtn(false);
      props.enableDisableStatusBtn(false);
      props.enableDisableSrlNumber(false);
    }
    else
      return;
  };

  const gridKey = "5c3709e6-94a5-4c6a-8f74-273385fd4bfe";
  const [currentLayout, setCurrentLayout] = useState("Default");
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", props.accessToken,null, currentLayout); }, [currentLayout]);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", props.accessToken, state, currentLayout); }, [gridKey, currentLayout]);

  return (
    <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
      ref={dataGrid}
      dataSource={props.data}
      showBorders={true}
      className={props.searchPanelStatus ? "GridHeightAccordianOpen-tabs" : "GridHeightAccordianClose-tabs"}
      columnAutoWidth={true}
      hoverStateEnabled={true}
      allowColumnResizing={true}
      allowColumnReordering={true}
      remoteOperations={true}
      onSelectionChanged={onSelectionChanged}
    >
      <Selection mode="single" />
      <ColumnChooser enabled={true}
        title="Choose Column"
        width={290}
        height={290}
        sortOrder="asc"
      >
        <ColumnChooserSearch
          enabled={true}
          editorOptions={{ placeholder: 'Search column' }} />
      </ColumnChooser>
      <ColumnHeaderFilter />
      <Export enabled={true} allowExportSelectedData={true} text="Export" />
      <Sorting visible={true} mode="multiple" />
      <LoadPanel enabled={true} />
      <Paging defaultPageSize={10} />
      <Pager
        visible={true}
        showPageSizeSelector={true}
        allowedPageSizes={allowedPageSizes}
        showNavigationButtons={true}
      />
      <FilterRow visible={true} />
      <FilterPanel visible={true} />
      <StateStoring
        enabled={true}
        type="custom"
        customLoad={loadState}
        storageKey={gridKey}
        customSave={saveState}
      />
      <Column dataField="lotCode" caption="Lot Code"></Column>
      <Column dataField="itemCode" caption="Item Code"></Column>
      <Column dataField="itemDescription1" caption="Item Description 1"></Column>
      <Column dataField="itemDescription2" caption="Item Description 2"></Column>
      <Column dataField="itemStatus" caption="Item Status"></Column>
      <Column dataField="itemClass" caption="Item Class"></Column>
      <Column dataField="itemSubClass" caption="Item Sub Class"></Column>
      <Column dataField="lotDescription1" caption="Lot Description 1" ></Column>
      <Column dataField="lotDescription2" caption="Lot Description 2" ></Column>
      <Column dataField="lotStatus" caption="Lot Status" ></Column>
      <Column dataField="subLotCode" caption={Localization.formatMessage('IMSUBLOT.SUBLOTCODE', 'Sublot Code')}></Column>
      <Column dataField="subLotDescription1" caption={Localization.formatMessage('IMSUBLOT.DESCRIPTION_1', 'Description 1')} ></Column>
      <Column dataField="subLotDescription2" caption={Localization.formatMessage('IMSUBLOT.DESCRIPTION_2', 'Description 2')} ></Column>
      <Column dataField="subLotStatus" caption={Localization.formatMessage('IMSUBLOT.STATUS', 'Status')} ></Column>
      <Column dataField="subLotGrossWeight" caption={Localization.formatMessage('IMSUBLOT.GROSSWEIGHT', 'Unit Gross Wt')} ></Column>
      <Column dataField="subLotNetWeight" caption={Localization.formatMessage('IMSUBLOT.NETWEIGHT', 'Unit Net Wt')} ></Column>
      <Column dataField="dateIntroduce" dataType="date" caption={Localization.formatMessage('IMSUBLOT.DATEINTRODUCED', 'Introduced DT')} ></Column>
      <Column dataField="dateAvailable" dataType="date" caption={Localization.formatMessage('IMSUBLOT.DATEAVAILABLE', 'Available DT')} ></Column>
      <Column dataField="subLotOnHand" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.ON_HAND', 'On Hand')} format="#,##0.00"></Column>
      <Column dataField="subLotAvailable" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.AVAILABLE', 'Available')} format="#,##0.00"></Column>
      <Column dataField="subLotNetAvailable" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.NETAVAILABLE', 'Net Available')} format="#,##0.00"></Column>
      <Column dataField="subLotUDFCode1" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDCODE_1', 'Code 1')} visible={false}></Column>
      <Column dataField="subLotUDFCode2" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDCODE_2', 'Code 2')} visible={false}></Column>
      <Column dataField="subLotUDFCode3" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDCODE_3', 'Code 3')} visible={false}></Column>
      <Column dataField="subLotUDFCode4" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDCODE_4', 'Code 4')} visible={false}></Column>
      <Column dataField="subLotUDFCode5" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDCODE_5', 'Code 5')} visible={false}></Column>
      <Column dataField="subLotUDFCode6" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDCODE_6', 'Code 6')} visible={false}></Column>
      <Column dataField="subLotUDFCode7" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDCODE_7', 'Code 7')} visible={false}></Column>
      <Column dataField="subLotUDFCode8" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDCODE_8', 'Code 8')} visible={false}></Column>
      <Column dataField="subLotUDFCode9" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDCODE_9', 'Code 9')} visible={false}></Column>
      <Column dataField="subLotUDFCode10" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDCODE_10', 'Code 10')} visible={false}></Column>
      <Column dataField="subLotUDFRef1" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDREFERENCE_1', 'Reference 1')} visible={false}></Column>
      <Column dataField="subLotUDFRef2" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDREFERENCE_2', 'Reference 2')} visible={false}></Column>
      <Column dataField="subLotUDFRef3" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDREFERENCE_3', 'Reference 3')} visible={false}></Column>
      <Column dataField="subLotUDFRef4" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDREFERENCE_4', 'Reference 4')} visible={false}></Column>
      <Column dataField="subLotUDFRef5" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDREFERENCE_5', 'Reference 5')} visible={false}></Column>
      <Column dataField="subLotUDFRef6" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDREFERENCE_6', 'Reference 6')} visible={false}></Column>
      <Column dataField="subLotUDFRef7" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDREFERENCE_7', 'Reference 7')} visible={false}></Column>
      <Column dataField="subLotUDFRef8" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDREFERENCE_8', 'Reference 8')} visible={false}></Column>
      <Column dataField="subLotUDFRef9" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDREFERENCE_9', 'Reference 9')} visible={false}></Column>
      <Column dataField="subLotUDFRef10" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDREFERENCE_10', 'Reference 10')} visible={false}></Column>
      <Column dataField="subLotUDFDate1" dataType="date" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDDATE_1', 'Date 1')} visible={false}></Column>
      <Column dataField="subLotUDFDate2" dataType="date" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDDATE_2', 'Date 2')} visible={false}></Column>
      <Column dataField="subLotUDFDate3" dataType="date" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDDATE_3', 'Date 3')} visible={false}></Column>
      <Column dataField="subLotUDFDate4" dataType="date" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDDATE_4', 'Date 4')} visible={false}></Column>
      <Column dataField="subLotUDFDate5" dataType="date" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDDATE_5', 'Date 5')} visible={false}></Column>
      <Column dataField="subLotUDFDate6" dataType="date" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDDATE_6', 'Date 6')} visible={false}></Column>
      <Column dataField="subLotUDFDate7" dataType="date" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDDATE_7', 'Date 7')} visible={false}></Column>
      <Column dataField="subLotUDFDate8" dataType="date" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDDATE_8', 'Date 8')} visible={false}></Column>
      <Column dataField="subLotUDFDate9" dataType="date" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDDATE_9', 'Date 9')} visible={false}></Column>
      <Column dataField="subLotUDFDate10" dataType="date" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDDATE_10', 'Date 10')} visible={false}></Column>
      <Column dataField="subLotUDFQty1" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDQUANTITY_1', 'Quantity 1')} visible={false}></Column>
      <Column dataField="subLotUDFQty2" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDQUANTITY_2', 'Quantity 2')} visible={false}></Column>
      <Column dataField="subLotUDFQty3" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDQUANTITY_3', 'Quantity 3')} visible={false}></Column>
      <Column dataField="subLotUDFQty4" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDQUANTITY_4', 'Quantity 4')} visible={false}></Column>
      <Column dataField="subLotUDFQty5" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDQUANTITY_5', 'Quantity 5')} visible={false}></Column>
      <Column dataField="subLotUDFQty6" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDQUANTITY_6', 'Quantity 6')} visible={false}></Column>
      <Column dataField="subLotUDFQty7" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDQUANTITY_7', 'Quantity 7')} visible={false}></Column>
      <Column dataField="subLotUDFQty8" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDQUANTITY_8', 'Quantity 8')} visible={false}></Column>
      <Column dataField="subLotUDFQty9" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDQUANTITY_9', 'Quantity 9')} visible={false}></Column>
      <Column dataField="subLotUDFQty10" caption={Localization.formatMessage('IMSUBLOT.USERDEFINEDQUANTITY_10', 'Quantity 10')} visible={false}></Column>
      <Column dataField="dateExpiration" caption={Localization.formatMessage('IMSUBLOT.DATEEXPIRATION', 'Expiration Dt')} dataType="date" visible={false}></Column>
      <Column dataField="inventoryUnitUOM" caption={Localization.formatMessage('IMSUBLOT.INVENTORYUNITUOM', 'Inventory Unit UOM', true)} visible={false}></Column>
      <Column dataField="piecesPerUnitUOM" caption={Localization.formatMessage('IMSUBLOT.PIECESPERUNITUOM', 'Pieces Per Unit UOM', true)} visible={false}></Column>
      <Column dataField="piecesPerUnitQuantity" caption={Localization.formatMessage('IMSUBLOT.PIECESPERUNITQUANTITY', 'Pieces Per Unit Qty', true)} visible={false}></Column>
      <Column dataField="unitsPerPackageUOM" caption={Localization.formatMessage('IMSUBLOT.UNITSPERPACKAGEUOM', 'Units / Package UOM')} visible={false}></Column>
      <Column dataField="unitsPerPackageQuantity" caption={Localization.formatMessage('IMSUBLOT.UNITSPERPACKAGEQUANTITY', 'Units / Package Qty')} visible={false}></Column>
      <Column dataField="packagesPerShippingUnitUOM" caption={Localization.formatMessage('IMSUBLOT.PACKAGESPERSHIPPINGUNITUOM', 'Packages Per Shipping Unit UOM', true)} visible={false}></Column>
      <Column dataField="packagesPerShippingUnitQty" caption={Localization.formatMessage('IMSUBLOT.PACKAGESPERSHIPPINGUNITQTY', 'Packages Per Shipping Unit Qty', true)} visible={false}></Column>
      <Column dataField="unitVolumeUOM" caption={Localization.formatMessage('IMSUBLOT.UNITVOLUMEUOM', 'Unit Volume UOM', true)} visible={false}></Column>
      <Column dataField="unitVolumeQuantity" caption={Localization.formatMessage('IMSUBLOT.UNITVOLUMEQUANTITY', 'Unit Volume Qty', true)} visible={false}></Column>
      <Column dataField="unitAreaUOM" caption={Localization.formatMessage('IMSUBLOT.UNITAREAUOM', 'Unit Area UOM', true)} visible={false}></Column>
      <Column dataField="unitAreaQuantity" caption={Localization.formatMessage('IMSUBLOT.UNITAREAQUANTITY', 'Unit Area Qty', true)} visible={false}></Column>
      <Column dataField="netWeightUOM" caption={Localization.formatMessage('IMSUBLOT.NETWEIGHTUOM', 'Unit Net Wt UOM')} visible={false}></Column>
      <Column dataField="grossWeightUOM" caption={Localization.formatMessage('IMSUBLOT.GROSSWEIGHTUOM', 'Unit Gross Wt UOM')} visible={false}></Column>
      <Column dataField="subLotInOrdered" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.IN_ORDERED', 'In Ordered')} visible={false} format="#,##0.00"></Column>
      <Column dataField="subLotOutOrdered" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.OUT_ORDERED', 'Out Ordered')} visible={false} format="#,##0.00"></Column>
      <Column dataField="subLotInReceiving" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.IN_RECEIVING', 'In Receiving')} visible={false} format="#,##0.00"></Column>
      <Column dataField="subLotOutShipped" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.OUT_SHIPPED', 'Out Shipped')} visible={false} format="#,##0.00"></Column>
      <Column dataField="subLotInBackOrder" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.IN_BACKORDER', 'In Back Order')} visible={false} format="#,##0.00"></Column>
      <Column dataField="subLotOutBackOrder" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.OUT_BACKORDER', 'Out Back Order')} visible={false} format="#,##0.00"></Column>
      <Column dataField="subLotInUnavailable" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.IN_UNAVAILABLE', 'In Unavailable')} visible={false} format="#,##0.00"></Column>
      <Column dataField="subLotOutUnavailable" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.OUT_UNAVAILABLE', 'Out Unavailable')} visible={false} format="#,##0.00"></Column>
      <Column dataField="subLotInFuture" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.IN_FUTURE', 'In Future')} visible={false} format="#,##0.00"></Column>
      <Column dataField="subLotOutFuture" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.OUT_FUTURE', 'Out Future')} visible={false} format="#,##0.00"></Column>
      <Column dataField="subLotSize1" caption={Localization.formatMessage('IMSUBLOT.SIZE_1', 'Size 1')} visible={false}></Column>
      <Column dataField="subLotSize2" caption={Localization.formatMessage('IMSUBLOT.SIZE_2', 'Size 2')} visible={false}></Column>
      <Column dataField="alternateId" caption={Localization.formatMessage('IMSUBLOT.ALTERNATEID', 'Alternate ID')} visible={false}></Column>
      <Column dataField="storageBillingsStartDate" dataType="date" caption={Localization.formatMessage('IMSUBLOT.STORAGEBILLINGSTARTDATE', 'Storage Billings Start Dt')} visible={false}></Column>
      <Column dataField="diffDays" caption="Nr of Days" visible={false}></Column>
      <Column dataField="subLotInTransactionNumber" caption={Localization.formatMessage('IMSUBLOT.INTRANSACTIONNUMBER', 'In Transaction#')} visible={false}></Column>
      <Toolbar>
        <Item location="before">
          <Button
            disabled={props.locbtnDisable}
            type="default"
            text="Location"
            onClick={props.openLocations}
          >
          </Button>
        </Item>
        <Item location="before">
          <Button
            disabled={props.SerialNumberBtnDisable}
            type="default"
            className="gridTopButton"
            text="Serial Numbers"
            onClick={props.openSerialnumberPopUp}
          >
          </Button>
        </Item>
        <Item location="before">
          <Button
            disabled={props.statusbtnDisable}
            type="default"
            className="gridTopButton"
            text="Status"
            onClick={props.openStatus}
          >
          </Button>
        </Item>
        <Item location="after">
          <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
        </Item>
        <Item name="exportButton" />
        <Item name="columnChooserButton" />
      </Toolbar>
    </DataGrid>
  );
};
